require('./RASuitabilityTestFailure.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ utilities
import { FormattedText } from 'core/i18n';

const RASuitabilityTestFailure = ({ exitTest }) => {
    return (
        <section className="ra-suitability-test-failure">
            <div className="ra-suitability-test-failure__icon-container">
                <i className="ra-suitability-test-failure__icon" />
            </div>
            <div className="ra-suitability-test-failure__title">
                <div className="ra-suitability-test-failure__title-text">
                    <FormattedText value="raSuitabilityTestFailure-title" />
                </div>
            </div>
            <div className="ra-suitability-test-failure__disclaimer">
                <div className="ra-suitability-test-failure__disclaimer-text">
                    <FormattedText value="raSuitabilityTestFailure-disclaimer" />
                </div>
            </div>
            <br />
            <div className="ra-suitability-test-failure__link">
                <a href="#" onClick={exitTest}>
                    <div className="ra-suitability-test-failure__link-text">
                        <FormattedText value="raSuitabilityTestFailure-finishLinkLabel" />
                    </div>
                </a>
            </div>
            <div className="ra-suitability-test-failure__footer visible-xs"></div>
        </section>
    );
};

RASuitabilityTestFailure.propTypes = {
    exitTest: PropTypes.func.isRequired,
    onResetTest: PropTypes.func,
};

module.exports = RASuitabilityTestFailure;
